import { StudentNote } from "@/utils/entities";
import api from "./config";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

function parseNoteItem(item: StudentNote): StudentNote {
  return {
    ...item,
    createdAtText: item.createdAt
      ? format(new Date(item.createdAt), "dd/MM/yyyy 'às' HH:mm", {
          locale: ptBR,
        })
      : undefined,
  };
}

async function getAll(studentId: string): Promise<StudentNote[]> {
  const { notes } = (await api.get(`/student/${studentId}/notes`)).data;

  return (notes as StudentNote[]).map(parseNoteItem);
}

async function create({
  studentId,
  content,
}: {
  studentId: string;
  content: string;
}): Promise<StudentNote> {
  const { note } = (
    await api.post(`/student/${studentId}/note`, { content })
  ).data;

  return parseNoteItem(note as StudentNote);
}

async function deleteNote({
  studentId,
  noteId,
}: {
  studentId: string;
  noteId: string;
}) {
  return (await api.delete(`/student/${studentId}/note`, { data: { noteId } }))
    .data;
}

async function update({
  studentId,
  noteId,
  content,
}: {
  studentId: string;
  noteId: string;
  content: string;
}): Promise<StudentNote> {
  const { note } = (
    await api.patch(`/student/${studentId}/note`, { noteId, content })
  ).data;

  return parseNoteItem(note as StudentNote);
}

export const StudentNoteService = {
  getAll,
  create,
  delete: deleteNote,
  update,
};
